import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import reportWebVitals from './reportWebVitals';

// Lazy-load application roots to split legacy and new bundles.
const LegacyApp = React.lazy(() => import('./LegacyApp'));
const NewApp = React.lazy(() => import('./NewApp'));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <RecoilRoot>
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            {/* New UI-kit routes */}
            <Route path="/*" element={<NewApp />} />
            {/* Legacy application (default) */}
            <Route path="/old/*" element={<LegacyApp />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </RecoilRoot>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
